import { observable, action } from "mobx"
import request from "app/vendor/request"
import config from "app/config"
import { message } from "antd"

export default class Store {
  @observable detailData = {}
  @observable resultData = {}
  @observable pgtaDetailData = {}
  @observable summaries = []

  @action getSummaries = (reportId) => {
    return request.get(`${config.backend}/array-pgt/reports/${reportId}/summaries`)
      .checkToken()
      .commonDispose()
      .then(
        res => {
          this.summaries = res
          return Promise.resolve()
        },
        err => {
          message.error(err.message)
          return Promise.reject()
        }
      )
  }
  @action uploadFile = (reportId, file, dir) => {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('path', dir.folder.slice(0, -1))
    formData.append('resultType', dir.resultType)

    return request.post(`${config.backend}/array-pgt/reports/${reportId}/file`)
      .checkToken()
      .send(formData)
      .commonDispose()
      .then(res => {
        message.success('上传成功')
        return Promise.resolve(res)
      }, err => {
        message.error(err.message)
        return Promise.reject(err)
      })
  }

  @action getDetailData = (reportId) => {
    return request.get(`${config.backend}/array-pgt/reports/${reportId}`)
      .checkToken()
      .commonDispose()
      .then(
        res => {
          this.detailData = res
          return Promise.resolve(res)
        },
        err => {
          message.error(err.message)
        }
      )
  }

  @action getResultData = (reportId, resultType, path) => {
    return request.get(`${config.backend}/array-pgt/reports/${reportId}?resultType=${resultType}&path=${path}`)
      .checkToken()
      .commonDispose()
      .then(
        res => {
          this.resultData = res
          return Promise.resolve(res)
        },
        err => {
          message.error(err.message)
        }
      )
  }

  @action getPgtaDetailData = (reportId, fileId) => {
    return request.get(`${config.backend}/array-pgt/reports/${reportId}/pgt-a?fileNumber=${fileId}`)
      .checkToken()
      .commonDispose()
      .then(
        res => {
          this.pgtaDetailData = res
          return Promise.resolve(res)
        },
        err => {
          message.error(err.message)
        }
      )
  }

  @action downloadReport = (reportId) => {
    return request.get(`${config.backend}/array-pgt/reports/${reportId}/download`)
      .checkToken()
      .commonDispose()
  }

  static fromJS() {
    const store = new Store()
    return store
  }
}


// WEBPACK FOOTER //
// ./src/app/stores/arrayPgt/haplotypeReport.js